import React, { useState, useEffect } from "react";
import styles from "./Registration.module.css";
import { useNavigate } from "react-router-dom";
import config from "../../../settings/config";
import { useToast } from "../../../context/ToastContext";

const Registration = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [successButton, setSuccessButton] = useState(false);
    const [loading, setLoading] = useState(false);
    const { setToast } = useToast();

    const showToast = (message, type, time) => {
        setToast({ message, type });
        setTimeout(() => setToast(null), time);
    };

    useEffect(() => {
        if (email.length > 0 && password.length > 0
            && confirmPassword.length > 0 && password === confirmPassword
        ) {
            setSuccessButton(true);
        } else {
            setSuccessButton(false);
        }
    }, [password, email, confirmPassword]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Проверка совпадения пароля
        if (!(email.length > 0 && password.length > 0
            && confirmPassword.length > 0)) {
            showToast("Заполните все поля", "warn", 3000 );
            return;
        }
        if (password !== confirmPassword) {
            showToast("Пароли не совпадают", "warn", 3000 );
            return;
        }
        setLoading(true);

        try {
            const response = await fetch(`${config.app.host}/api/v1/registration`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: email,
                    password: password,
                    confirmPassword: confirmPassword,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "При регистрации произошла ошибка, попробуйте снова!");
            }

            showToast("Регистрация прошла успешно, ожидайте активации аккаунта!", "success", 3000 );
            navigate('/');
        } catch (err) {
            showToast(err.message, "error", 3000 );
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        navigate(-1);
    }

    return (
        <div className={styles.container}>
            <h3>Регистрация</h3>
            <div className={styles.form}>
                E-mail
                <input
                    className={styles.formInput}
                    type="text"
                    placeholder="Введите E-mail"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                Пароль
                <input
                    className={styles.formInput}
                    type="password"
                    placeholder="Введите пароль"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                Подтверждение пароля
                <input
                    className={styles.formInput}
                    type="password"
                    placeholder="Повторите пароль"
                    required
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <div className={styles.delimeterStyle}></div>
                <button
                    className={successButton ? styles.buttonContinueOn : styles.buttonContinue}
                    onClick={handleSubmit}
                >
                    {loading ? "Регистрация..." : "Зарегистрироваться"}
                </button>
                <button
                    className={styles.backButton}
                    onClick={handleBack}
                >
                    Назад
                </button>
            </div>
        </div>
    );
};

export default Registration;
